__turbopack_context__.v({
  "statBoxWrapper": "Rollercoasters-module__2NsOhW__statBoxWrapper",
  "themeParkLogoFigure": "Rollercoasters-module__2NsOhW__themeParkLogoFigure",
  "themeParkLogoImage": "Rollercoasters-module__2NsOhW__themeParkLogoImage",
});
